import React from "react";
import "./menu.css";

function Menu() {
  return (
    <nav className="navbar fixed-top navbar-expand-md navbar-dark">
      <div className="container">

        {/* LOGO */}
        <a className="navbar-brand" href="/#banner">
          <img src="Images/logo.png" alt="Logo" height="58" />
        </a>

        {/* BOTÃO MOBILE */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* LINKS */}
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto">

            <li className="nav-item">
              <a className="nav-link" href="#banner">Home</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#servicos">Serviços</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#preco">Planos e preços</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="/blog">Artigos</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#quem-somos">Quem Somos</a>
            </li>

            <li className="nav-item">
              <a className="nav-link" href="#contato">Contato</a>
            </li>

          </ul>
        </div>

      </div>
    </nav>
  );
}

export default Menu;
